import { clsx, type ClassValue } from 'clsx'

import type { LocalizedCopy, Locale } from '@/types/site'

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs)
}

export function getLocalizedValue<T>(value: LocalizedCopy<T>, locale: Locale): T {
  return value[locale]
}

export function formatLocalizedNumber(value: number, locale: Locale) {
  return new Intl.NumberFormat(locale === 'ar' ? 'ar-KW' : 'en-US').format(value)
}

/** Western digits 0–9 only; use for stats and counters even when the UI is Arabic */
export function formatWesternNumber(value: number) {
  return new Intl.NumberFormat('en-US').format(value)
}
